import Trustpilot from "../../../../public/static/images/trustpiloticon.svg";
export default function TrustpilotIcon({
  width = "25",
  height = "25",
}: {
  width?: string;
  height?: string;
}) {
  return <Trustpilot height={height} width={width} />;
}
